// extracted by mini-css-extract-plugin
export default {"checkInput":"CheckInput_checkInput__arGyO","checkbox":"CheckInput_checkbox__laUlK"};